import React, { useState } from 'react';
import I18n, { translate } from '@utils/i18n';
import useDebounce from '@hooks/useDebounce';
import Table, { TableSize } from '@components/Table';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import SearchPanel from '@components/SearchPanel';
import getColumnsDefinition from './columns';
import { namespace } from './constants';
import useExternalForms from './useExternalForms';
import ExternalFormDetail from './ExternalFormDetail';
import ImportForm from './ImportForm';
import '../../FormLibrary/styles.scss';
function ExternalFormsContainer({ frequenciesForSelect, workOrderFormsEnabled, isInspectpointUser, territoriesForSelect }) {
    const [searchText, setSearchText] = useState('');
    const searchTextDebounced = useDebounce(searchText);
    const { forms, addExternalForm, loading, updateExternalForm } = useExternalForms({
        searchText: searchTextDebounced,
        frequencies: frequenciesForSelect
    });
    const [openDetailForm, setOpenDetailForm] = useState(null);
    const [isImportFormOpen, setisImportFormOpen] = useState(false);
    const onClickItem = (form) => {
        setOpenDetailForm(form);
    };
    const onFormImported = (form) => {
        addExternalForm(form);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "workspace__body" },
            React.createElement("div", { className: "workspace__major--listing" },
                React.createElement("div", { className: "workspace__header" },
                    React.createElement("div", { className: "header__main" },
                        React.createElement("h1", { className: "workspace__title" }, translate('title', { namespace })))),
                React.createElement("article", { id: "filters", className: "qmb-filters" },
                    React.createElement("button", { type: "button", className: "qmb-control mt-1 brushaway-button", onClick: () => {
                            setisImportFormOpen(true);
                        } },
                        React.createElement("i", { className: "fa-light fa-circle-plus" }),
                        translate('add_form', { namespace })),
                    React.createElement("div", { className: "filters__group--search" },
                        React.createElement(SearchPanel, { value: searchText, 
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                            placeholder: I18n.t('filters.search'), onChange: setSearchText }))),
                React.createElement("div", null,
                    loading && (React.createElement("div", { className: "loading-center" },
                        React.createElement(Loader, { size: LoaderSizes.xlarge }))),
                    !loading && (React.createElement(Table, { columns: getColumnsDefinition({ onClickItem, territories: territoriesForSelect }), data: forms, size: TableSize.Full, variant: "listing" })),
                    !loading && forms.length === 0 && (React.createElement("div", { className: "no-data-message" }, translate('no_data', { namespace })))))),
        React.createElement(ExternalFormDetail, { form: openDetailForm, onClose: () => setOpenDetailForm(null), onSubmit: updateExternalForm, frequencies: frequenciesForSelect, hasWorkOrderForms: workOrderFormsEnabled, isInspectpointUser: isInspectpointUser, territories: territoriesForSelect }),
        React.createElement(ImportForm, { isImportFormOpen: isImportFormOpen, onClose: () => setisImportFormOpen(false), onFormImported: onFormImported })));
}
export default ExternalFormsContainer;
